export { default } from './ShieldAlternateOutline'
